import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApiService } from '../api.service';

@Component({
  templateUrl: './preorders.component.html',
  styleUrls: ['./preorders.component.scss']
})
export class PreordersComponent implements OnInit {
  baseUrl: string;

  order: any = {
    products: [],
    reduc: 0,
    export: false,
    fromNew: true
  };

  language: string;
  page: any;

  constructor(public api: ApiService) { }

  ngOnInit(): void {
    this.language = "fr";
    
    window.addEventListener('scroll', function (event) {
      const iframe = document.getElementById('my-shoop') as HTMLIFrameElement;
      if (iframe && iframe.contentWindow) {
        iframe.contentWindow.postMessage(
          {
            type: 'scroll',
            scrollY: window.scrollY,
            clientRect: iframe.getBoundingClientRect(),
          },
          '*'
        );
      }
    });

    window.addEventListener('message', function (event) {
      const height = event.data['height'];
      if (height) {
        const iframe = document.getElementById('my-shoop') as HTMLElement;
        if (iframe) {
          iframe.style.height = height + event.data['footerHeight'] + 20 + 'px';
        }
      }
    }); 
  }
}
